import { Grid, Link, Typography, makeStyles } from "@material-ui/core";
import { LessonResult } from "@hubcapp/components/Calendar/components/Modals/ViewLessonModal/types";
import { Link as RouterLink } from "react-router-dom";
import { UserType } from "@hubcapp/types";
import Label from "@ds-developer/label";
import React from "react";

const useStyles = makeStyles(theme => ({
  link: {
    color: theme.palette.primary.main,
  },
}));

interface IProps {
  lesson: LessonResult;
}

export const ViewLessonModalLeanerInfo: React.FC<IProps> = ({ lesson }) => {
  const classes = useStyles();
  const getPropositionAllocationText = () => {
    if (!lesson || !lesson?.instructor || !lesson.instructor?.propositions)
      return "";
    const propositionAllocation =
      lesson.instructor?.propositions[0].proposition;

    return `${propositionAllocation.brand} ${
      lesson?.franTransmission ?? propositionAllocation.transmission
    } Learner`;
  };

  const phoneSource =
    lesson?.learner.mobileNumber || lesson?.learner.landlineNumber;

  const addressSource =
    lesson?.learner.pickupAddress || lesson?.learner.address;

  const showSSLabel = lesson?.learner.sourcedBy === UserType.Instructor;

  const mobileHref = `tel:${phoneSource}`;
  const smsHref = `sms:${phoneSource}`;

  return (
    <>
      <Grid container item spacing={showSSLabel ? 2 : 0}>
        <Grid item xs={"auto"} lg={3}>
          <Label color={"root"}>{getPropositionAllocationText()}</Label>
        </Grid>
        {showSSLabel && (
          <Grid item xs={"auto"} lg={3}>
            <Label color={"root"}>Self sourced</Label>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="caption">Learner</Typography>
        <RouterLink to={`/learners/${lesson.learner.id}`}>
          <Typography>{`${lesson.learner.name.firstName} ${lesson.learner.name.lastName}`}</Typography>
        </RouterLink>
      </Grid>
      {phoneSource && (
        <Grid item xs={12} lg={6}>
          <Typography variant="caption">Phone</Typography>
          <Grid container>
            <Grid item xs={6}>
              <Link className={classes.link} href={mobileHref}>
                {phoneSource}
              </Link>
            </Grid>
            <Grid item xs={6}>
              <Link className={classes.link} href={smsHref}>
                Send SMS
              </Link>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography variant="caption">Address</Typography>
        <Typography>
          {addressSource
            ? `${addressSource.line1}, ${addressSource?.postcode}`
            : "-"}
        </Typography>
      </Grid>
    </>
  );
};
